declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    secondaryButton: true;
    refreshButton: true;
    roundButton: true;
    roundButtonChat: true;
    deleteButton: true;
    categoryButton: true;
    cancelButton: true;
  }
}


export default function MuiButton(theme: any) {
  return {
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            borderRadius: theme.shape.borderRadius * 50,
            color: theme.palette.grey[700],
            fontWeight: "normal",
            backgroundColor: theme.palette.grey[0],
            textTransform: "initial",
            opacity: "1",
            transition: "all .3s ease-in-out",

            "&:hover": {
              backgroundColor: theme.palette.grey[0],
              opacity: ".8",
            },
          },
        },

        {
          props: { variant: "secondaryButton" },
          style: {
            borderRadius: theme.shape.borderRadius * 50,
            backgroundColor: "#474747",
            color: "#FFFFFF",
            fontWeight: "normal",
            textTransform: "initial",
            opacity: "1",
            transition: "all .3s ease-in-out",
            padding: "0 20px",
            fontSize: "11px",
            height: "36px",

            "&:hover": {
              backgroundColor: "#474747",
              color: "#FFFFFF",
              opacity: 0.8,
            },
            "& .MuiButton-endIcon": {
              width: "24px",
              height: "24px",
            },
          },
        },
        {
          props: { variant: "refreshButton" },
          style: {
            marginTop: "3px",
            lineHeight: "16px",
            backgroundColor: theme.palette.grey[900],
            height: "56px",
            width: "262px",
            borderRadius: "100px",
            color: theme.palette.grey[0],
            fontWeight: 400,
            textTransform: "lowercase",
            "&.MuiButtonBase-root:hover": {
              backgroundColor: theme.palette.grey[900],
            },
          },
        },
        {
          props: { variant: "text" },
          style: {
            color: theme.palette.grey[0],
            fontSize: '14px',
            lineHeight: '16px',
            transition: "opacity .3s ease-in-out",
            "& .MuiButton-startIcon": {
              color: "transparent",
              transform: "translate(0, 0)",
              transition: "all .3s ease-in-out",
            },
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8,
              "& .MuiButton-startIcon": {
                color: "transparent",
                transform: "translate(5px, 0)",
              },
            },
          },
        },

        {
          props: { variant: "roundButton" },
          style: {
            backgroundColor: theme.palette.grey[0],
            borderRadius: '50%',
            minHeight: '32px',
            minWidth: '32px',
            transition: "opacity .3s ease-in-out",

            "&:hover": {
              backgroundColor: theme.palette.grey[0],
            },
          },
        },
        {
          props: { variant: "roundButtonChat" },
          style: {
            backgroundColor: theme.palette.grey[700],
            borderRadius: '50%',
            width: '56px',
            height: '56px',
            minWidth: '56px',
            marginLeft: '10px',
            transition: "opacity .3s ease-in-out",
            padding: 0,

            "&:hover": {
              backgroundColor: theme.palette.grey[700],
            },
          },
        },

        {
          props: { variant: "categoryButton" },
          style: {
            borderRadius: theme.shape.borderRadius * 50,
            backgroundColor: "transparent",
            color: theme.palette.grey[0],
            fontWeight: "normal",
            opacity: "1",
            transition: "all .3s ease-in-out",
            height: "56px",
            minWidth: "140px",
            whiteSpace: "nowrap",
            maxWidth: "212px",
            padding: "0px 22px 0px 24px",
            fontSize: "14px",
            lineHeight: "16px",

            "&:hover": {
              color: theme.palette.grey[0],
              backgroundColor: 'transparent',
              minWidth: "140px",
              height: "56px",
              lineHeight: "16px",

              "& .MuiTouchRipple-root": {
                display: "none",
              },
            },

            "&.Mui-disabled": {
              color: theme.palette.grey[700],
              backgroundColor: theme.palette.grey[0],
            },

            "&.Mui-focusVisible": {
              minWidth: "100px",
              color: theme.palette.grey[0],
              lineHeight: "16px",
            },

            "&.isActive": {
              backgroundColor: theme.palette.grey[0],
              color: theme.palette.grey[700],
              minWidth: "100px",
              height: "56px",
              lineHeight: "16px",
            },
            "&.isEditing": {
              maxWidth: "none",
              minWidth: "240px",
              paddingRight: "16px",
            },

            "& .MuiButton-endIcon": {
              marginTop: "4px",
              marginLeft: "20px",
              color: theme.palette.grey[0],
            },
            "& .MuiFormControl-root": {
              height: "auto",
              "& .MuiInputBase-root input": {
                padding: 0,
              },
            },
          },
        },
        {
          props: { variant: "deleteButton" },
          style: {
            "& .MuiTouchRipple-root": {
              display: "none",
            },
            backgroundColor: "#FA7269",
            borderRadius: theme.shape.borderRadius * 16,
            marginLeft: theme.spacing(56.2),
            marginTop: theme.spacing(1.25),
            color: "#333333",
            fontSize: "11px",
            padding: "16px 20px",
            lineHeight: theme.spacing(2),
            "& .MuiButton-endIcon": {
              color: "black",
              marginLeft: theme.spacing(2.5),
              marginTop: theme.spacing(0.62),
            },
          },
        },
        {
          props: { variant: "cancelButton" },
          style: {
            backgroundColor: "#FA7269",
            borderRadius: theme.shape.borderRadius * 16,
            color: "#333333",
            fontSize: "11px",
            padding: "0 20px",
            height: "36px",
            "&:hover": {
              backgroundColor: "#FA7269",
              opacity: 0.8,
            },
            "& .MuiButton-endIcon": {
              width: "24px",
              height: "24px",
            },
          },
        },
      ],
      styleOverrides: {
        root: {},
      },
    },
  };
}
